import React from "react";

export const DISC = {
  police: { label: "POLICE", color: "#3B82F6", bg: "rgba(59,130,246,0.12)" },
  fire: { label: "FIRE", color: "#EF4444", bg: "rgba(239,68,68,0.12)" },
  ems: { label: "EMS", color: "#10B981", bg: "rgba(16,185,129,0.12)" },
};

export const PRIORITY = {
  1: { label: "P1", color: "#DC2626", text: "CRITICAL" },
  2: { label: "P2", color: "#F59E0B", text: "HIGH" },
  3: { label: "P3", color: "#EAB308", text: "MEDIUM" },
  4: { label: "P4", color: "#6B7280", text: "LOW" },
  5: { label: "P5", color: "#4B5563", text: "ROUTINE" },
};

const chip = "font-mono text-[10px] font-bold px-1.5 py-0.5 uppercase whitespace-nowrap rounded-sm inline-flex items-center gap-1";

export function MultiAgencyBadge({ className = "" }) {
  return (
    <span data-testid="multi-agency-badge" className={`${chip} ${className}`}
      style={{ color: "#A855F7", background: "rgba(168,85,247,0.12)", border: "1px solid rgba(168,85,247,0.4)" }}>
      MULTI-AGENCY
    </span>
  );
}

export function DiscBadge({ discipline }) {
  const d = DISC[discipline] || { label: discipline?.toUpperCase(), color: "#9CA3AF" };
  return (
    <span data-testid={`disc-badge-${discipline}`} className={chip}
      style={{ color: d.color, background: `${d.color}1A`, border: `1px solid ${d.color}55` }}>
      {d.label}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const p = PRIORITY[priority] || PRIORITY[4];
  const critical = priority === 1;
  return (
    <span data-testid={`priority-badge-${priority}`}
      className={`${chip} ${critical ? "anim-pulse-alert" : ""}`}
      style={{ color: "#fff", background: p.color, border: `1px solid ${p.color}` }}>
      {p.label}
    </span>
  );
}

const LIVE_STATUSES = new Set(["active", "onscene", "enroute", "dispatched", "transport", "acknowledged", "delayed_onscene"]);

export function StatusChip({ status }) {
  const map = {
    pending: "#F59E0B", dispatched: "#3B82F6", active: "#DC2626", onscene: "#10B981",
    closed: "#6B7280", available: "#22C55E", enroute: "#3B82F6", transport: "#8B5CF6",
    busy: "#F59E0B", outofservice: "#6B7280", delayed_onscene: "#EA580C", directed_patrol: "#0EA5E9",
    acknowledged: "#0EA5E9",
  };
  const labels = { delayed_onscene: "DELAYED ON SCENE", outofservice: "OUT OF SERVICE", directed_patrol: "DIRECTED PATROL", acknowledged: "ACKNOWLEDGED" };
  const c = map[status] || "#9CA3AF";
  const live = LIVE_STATUSES.has(status);
  return (
    <span data-testid={`status-chip-${status}`} className={chip} style={{ color: c, background: `${c}1A`, border: `1px solid ${c}55` }}>
      {live && <span className="live-dot w-1.5 h-1.5 rounded-full after:content-[''] after:rounded-full"
        style={{ background: c }} />}
      {labels[status] || status}
    </span>
  );
}
